/**
 * Who takes part in an activity or Pick, and its teaching language
 * (docs/prd-homepage-redesign.md §4.2). Values mirror the Prisma enums.
 */
export const PARTICIPATIONS = ['PARENT_CHILD', 'KID_ONLY', 'ADULT_ONLY'] as const;
export type ParticipationValue = (typeof PARTICIPATIONS)[number];

export const ACTIVITY_LANGUAGES = ['ZH', 'EN', 'BILINGUAL'] as const;
export type ActivityLanguageValue = (typeof ACTIVITY_LANGUAGES)[number];

/** Picks may also be language-neutral (a museum, a farm). */
export const PICK_LANGUAGES = ['ZH', 'EN', 'BILINGUAL', 'NA'] as const;
export type PickLanguageValue = (typeof PICK_LANGUAGES)[number];

export function isParticipation(v: unknown): v is ParticipationValue {
  return typeof v === 'string' && (PARTICIPATIONS as readonly string[]).includes(v);
}

export function isActivityLanguage(v: unknown): v is ActivityLanguageValue {
  return typeof v === 'string' && (ACTIVITY_LANGUAGES as readonly string[]).includes(v);
}

export function isPickLanguage(v: unknown): v is PickLanguageValue {
  return typeof v === 'string' && (PICK_LANGUAGES as readonly string[]).includes(v);
}

/**
 * Booking requirements derived from participation for in-person activities.
 * participation is their single source; the two booleans are never set on their own.
 */
export function participationFlags(p: ParticipationValue): {
  childRequired: boolean;
  adultRequired: boolean;
} {
  switch (p) {
    case 'PARENT_CHILD':
      return { childRequired: true, adultRequired: true };
    case 'KID_ONLY':
      return { childRequired: true, adultRequired: false };
    case 'ADULT_ONLY':
      return { childRequired: false, adultRequired: true };
  }
}
